var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0292 7.09646L8.8132 11.3135L6.9702 9.46946C6.6772 9.17646 6.2022 9.17646 5.9092 9.46946C5.6162 9.76246 5.6162 10.2375 5.9092 10.5305L8.2822 12.9045C8.4232 13.0445 8.6132 13.1235 8.8132 13.1235C9.0112 13.1235 9.2022 13.0445 9.3432 12.9045L14.0902 8.15746C14.3832 7.86446 14.3832 7.38946 14.0902 7.09646C13.7972 6.80346 13.3222 6.80346 13.0292 7.09646Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.244 9.578C19.661 9.578 20 9.239 20 8.822V6.253C20 2.392 17.59 0 13.753 0H6.253C2.392 0 0 2.392 0 6.256V13.756C0 17.608 2.392 20 6.253 20H13.756C17.608 20 20 17.608 19.997 13.753C19.997 13.331 19.655 12.988 19.232 12.988C18.809 12.988 18.467 13.331 18.467 13.753C18.467 16.787 16.796 18.467 13.753 18.467H6.253C3.21 18.467 1.53 16.787 1.53 13.753V6.253C1.53 3.21 3.21 1.53 6.256 1.53H13.756C16.8 1.53 18.47 3.2 18.47 6.253V8.795V8.797C18.471 9.219 18.813 9.56 19.235 9.56V9.578H19.244Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.9abb3a1059ec8f5eee4857666462c2bb.svg";
export { ForwardRef as ReactComponent };